import type { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { Paper } from 'shared/ui/paper'

import type { ObjectApplication } from '../../model/types'

import s from './styles.module.scss'

interface Props {
  application: ObjectApplication
  onApprove: () => void
  onReject: () => void
}

export const ApplicationCard: FC<Props> = ({
  application,
  onApprove,
  onReject,
}) => {
  const { t } = useTranslation()

  return (
    <Paper
      padding={[12]}
      radius="16px"
      className={s.card}
    >
      <div className={s.content}>
        <span className={clsx('medium-12', s.dateBadge)}>
          {t('kyrgyzstan_block.my_objects.applications.date', {
            startDate: application.startDate,
            endDate: application.endDate,
          })}
        </span>

        <div className={s.info}>
          <span className={clsx('semi-bold-14', s.title)}>
            {application.title}
          </span>
          <span className={clsx('regular-12', s.details)}>
            {t('kyrgyzstan_block.my_objects.applications.details', {
              nightsCount: application.nightsCount,
              guestsCount: application.guestsCount,
            })}
          </span>
          <span className={clsx('regular-12', s.address)}>
            {application.address}
          </span>
        </div>

        <div className={s.divider} />

        <div className={s.actions}>
          <button
            type="button"
            className={clsx('semi-bold-14', s.actionButton, s.approveButton)}
            onClick={onApprove}
          >
            {t('kyrgyzstan_block.my_objects.applications.approve')}
          </button>
          <button
            type="button"
            className={clsx('semi-bold-14', s.actionButton, s.rejectButton)}
            onClick={onReject}
          >
            {t('kyrgyzstan_block.my_objects.applications.reject')}
          </button>
        </div>
      </div>
    </Paper>
  )
}
